import React from "react";
import styles from "./style/comp2.module.css";

export default function LocationComp({ name, description, isLayover }) {
    return (
        <div className={styles['parent-container']}>
            <div className={styles['up-container']}>
                <div className={styles['name']}>{name}</div>
                {isLayover && <div className={styles['layover']}>Layover</div>}
            </div>
            <div className={styles['down-container']}>
                {Array.isArray(description) ? (
                    <ul className={styles['description-list']}>
                        {description.map((item, idx) => (
                            <li key={idx} className={styles['description-list-item']}>
                                {item}
                            </li>
                        ))}
                    </ul>
                ) : (
                    description
                )}
            </div>
        </div>
    );
}